export enum ActionStatuses {
    Unspecified,
    New,
    'Sent to Clearing',
    Approved,
    Rejected,
    Restricted,
    Suspended,
    Closed,
}

export enum MarginTypes {
    None = 0,
    Cash = 1,
    Margin = 2,
    DayTrader = 4,
    MarginIra = 8,
}

export enum AnnualIncomeOptions {
    'Under $25,000' = '25,000',
    '$25,001 - $50,000' = '25,001-50,000',
    '$50,001 - $100,000' = '50,001-100,000',
    '$100,001 - $200,000' = '100,001-200,000',
    '$200,001 - $300,000' = '200,001-300,000',
    '$300,001 - $500,000' = '300,001-500,000',
    '$500,001 - $1,200,000' = '500,001-1,200,000',
    'Over $1,200,000' = '1,200,000',
}

export enum AnnualIncome {
    'Under $25,000',
    '$25,001 - $50,000',
    '$50,001 - $100,000',
    '$100,001 - $200,000',
    '$200,001 - $300,000',
    '$300,001 - $500,000',
    '$500,001 - $1,200,000',
    'Over $1,200,000',
}

export enum AnnualIncomeOptions {
    'Capital Preservation' = 'CAPITAL_PRESERVATION',
    'Growth' = 'GROWTH',
    'Growth Income' = 'GROWTH_INCOME',
    'Balanced' = 'BALANCED',
    'Income' = 'INCOME',
    'Speculation' = 'SPECULATION',
    'Maximum Growth' = 'MAXIMUM_GROWTH',
    'Other' = 'OTHER',
}

export enum RiskTolerance {
    'Low' = 'Low',
    'Medium' = 'Medium',
    'High' = 'High',
}

export enum RiskToleranceOptions {
    'Low' = 'Low',
    'Medium' = 'Medium',
    'High' = 'High',
}

export enum InvestmentObjectives {
    'CAPITAL_PRESERVATION' = 'Capital Preservation',
    'GROWTH' = 'Growth',
    'GROWTH_INCOME' = 'Growth Income',
    'BALANCED' = 'Balanced',
    'INCOME' = 'Income',
    'SPECULATION' = 'Speculation',
    'MAXIMUM_GROWTH' = 'Maximum Growth',
    'OTHER' = 'Other',
}

export enum InvestmentObjectivesOptions {
    'Capital Preservation' = 'CAPITAL_PRESERVATION',
    'Growth' = 'GROWTH',
    'Growth Income' = 'GROWTH_INCOME',
    'Balanced' = 'BALANCED',
    'Income' = 'INCOME',
    'Speculation' = 'SPECULATION',
    'Maximum Growth' = 'MAXIMUM_GROWTH',
    'Other' = 'OTHER',
}

export enum InvestmentExperience {
    'None' = 'None',
    'Limited' = 'Limited (1-2 Years)',
    'Good' = 'Good (3-5 Years)',
    'Extensive' = 'Extensive (5 years or more)',
}

export enum InvestmentExperienceOptions {
    'None' = 'None',
    'Limited (1-2 Years)' = 'Limited',
    'Good (3-5 Years)' = 'Good',
    'Extensive (5 years or more)' = 'Extensive',
}

export enum TimeHorizon {
    'SHORT' = 'Short (Less than 3 Years)',
    'AVERAGE' = 'Average (4-7 Years)',
    'LONG' = 'Long (8 Years+)',
}

export enum TimeHorizonOptions {
    'Short (Less than 3 Years)' = 'SHORT',
    'Average (4-7 Years)' = 'AVERAGE',
    'Long (8 Years+)' = 'LONG',
}

export enum LiquidityNeeds {
    'VERY_IMPORTANT' = 'Very Important',
    'SOMEWHAT_IMPORTANT' = 'Somewhat Important',
    'NOT_IMPORTANT' = 'Not Important',
}

export enum LiquidityNeedsOptions {
    'Very Important' = 'VERY_IMPORTANT',
    'Somewhat Important' = 'SOMEWHAT_IMPORTANT',
    'Not Important' = 'NOT_IMPORTANT',
}

export interface ISettingsAccountsDto {
    id: number;
    tenantId: number;
    enabled: boolean;
    cash: number;
    baseCash: number;
    currency: string;
    clearingAccount: string;
    createdDate: string;
    modifiedDate: string;
    status: ActionStatuses;
    isChanged: boolean;
    isInventory: boolean;
    isError: boolean;
    commissionPlan: string;
    optionLevel: number;
    marginType: MarginTypes;
    isAverageAccount: boolean;
    repCode: string;
    fdid: string;
    formDataReference: string;
    customerType: string;
    accountType: string;
    verificationRequest: ISettingsVerificationRequestAccountsDto;
}

export interface ISettingsVerificationRequestAccountsDto {
    firstName?: string;
    lastName?: string;
    entityName?: string;
    entityTaxId?: string;
    street: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;
    passport: string;
    ssn: string;
    phone: string;
    dob: string;
    liquidityNeeds: LiquidityNeeds;
    timeHorizon: string;
    investmentExperience: string;
    investmentObjectives: string;
    riskTolerance: string;
    annualIncomeMax: string;
    annualIncomeMin: string;
    taxBracket: string;
}

export interface IServiceKycResponse {
    result: 'RisksDetected' | 'Failed' | 'Passed';
    message: string;
    validationWarnings: string[];
}

export interface FilterRequest {
    accountNumber?: string;
    type: number; // assuming enum is represented as number
    fromDate: string; // ISO date string
    toDate: string;
    sortBy?: string;
    isAsc: boolean;
}

export interface TaxFormRequest {
    filterRequest: FilterRequest;
    accountType: string;
}
